var ResignOktaGroup;
(function (ResignOktaGroup) {
    ResignOktaGroup["User"] = "SECOK-P-BF_publisher_portal_resign_pipeline-User";
})(ResignOktaGroup || (ResignOktaGroup = {}));

const PublisherModuleDetail = {
    title: 'Publishing',
    nav: [
        {
            name: 'Resign',
            url: 'resign',
            groupsAllowed: [ResignOktaGroup.User],
        },
    ],
    loadModule: () => import('./bigfishgames-resign-pipeline-portal-module.module-1006c63d.mjs').then((m) => m.PortalModule),
};

/*
 * Public API Surface of hello-module
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PublisherModuleDetail };
